var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditorFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6 5.51818V12.6H1.4V1.4H5.8998V4.81818C5.8998 5.20478 6.2132 5.51818 6.5998 5.51818H10.5998C10.5999 5.51818 10.5999 5.51818 10.6 5.51818ZM9.7587 4.11818L8.88138 3.18769L7.2998 1.51026V4.11818H9.7587ZM0 1C0 0.447716 0.447715 0 1 0H7.36846C7.64388 0 7.9071 0.113594 8.09605 0.313987L9.9 2.22727L11.7276 4.16562C11.9026 4.35119 12 4.5966 12 4.85164V13C12 13.5523 11.5523 14 11 14H1C0.447715 14 0 13.5523 0 13V1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditorFile);
export default __webpack_public_path__ + "static/media/icon_editor_file.443579800409759996ef6d333a652d78.svg";
export { ForwardRef as ReactComponent };